export const AUTH_INIT = "auth/AUTH_INIT";
export const AUTH_SUCCESS = "auth/AUTH_SUCCESS";
export const AUTH_FAILURE = "auth/AUTH_FAILURE";
export const RESET_AUTH = "auth/RESET_AUTH";

export interface AuthState {
	uid: string | null;
	isAuthenticating: boolean;
	authenticatingService: string | null;
	authenticated: boolean;
	errorAuthenticating: Error | null;
}

interface ResetAuthAction {
	type: typeof RESET_AUTH;
}

interface AuthInitAction {
	type: typeof AUTH_INIT;
}

interface AuthSuccessAction {
	type: typeof AUTH_SUCCESS;
	uid: string;
}

interface AuthFailureAction {
	type: typeof AUTH_FAILURE;
	error: Error;
}

export type AuthActionTypes =
	| ResetAuthAction
	| AuthInitAction
	| AuthSuccessAction
	| AuthFailureAction;
